
























































import {Component, Prop, Ref, Vue} from 'vue-property-decorator';
import anime from "animejs"

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component
export default class JdsLoader extends Vue {
    @Prop({default: true}) loading!: boolean;
    @Prop({default: '300px'}) height!: string;

    @Ref() contentEl!: HTMLElement;
    @Ref() wrapperEl!: HTMLElement;
    @Ref() logoEl!: HTMLElement;

    loaderEnter(el: HTMLElement, done: ()=>void) {
        anime.timeline({
        }).add({
            // drop
            easing: 'easeInExpo',
            targets: this.logoEl,
            translateY: [-100, 0],
            scaleX: [0.8, 0.8],
            opacity: [0, 1],
            duration: 800,
        }).add({
            // squish
            easing: 'easeOutExpo',
            targets: this.logoEl,
            scaleX: [0.8, 1.3],
            scaleY: [1, 0.7],
            duration: 50,
            complete: done,
        }, '+800');
    }

    loaderMain(el: HTMLElement) {
        // do main loop
        anime.timeline({
            loop: true,
        }).add({
            // hop
            targets: this.logoEl,
            translateY: {
                delay: 40,
                value: [0, -50],
                easing: 'easeOutQuint',
            },
            scaleX: {
                duration: 100,
                value: [1.2, 1],
                easing: 'easeOutElastic(4, .8)',
            },
            scaleY: {
                duration: 100,
                value: [0.8, 1.1],
                easing: 'easeOutElastic(4, .8)',
            },
            duration: 300,
        }, 30).add({
            // hop
            targets: this.logoEl,
            translateY: {
                duration: 660,
                value: [-50, 0],
                easing: 'easeInQuint',
            },
            scaleX: {
                delay: 660,
                duration: 100,
                value: [1, 1.2],
                easing: 'easeOutBack',
            },
            scaleY: {
                delay: 660,
                duration: 100,
                value: [1.1, 0.8],
                easing: 'easeOutBack',
            },
            duration: 760,
        }, 350);
    }

    loaderLeave(el: HTMLElement, done: ()=>void) {
        const target = anime.get(this.contentEl, 'height') as string;
        const from = anime.get(el, 'height') as string;

        anime.timeline({
            easing: 'easeOutExpo',
            complete: () => {
                try {
                    this.contentEl.style.removeProperty("height");
                } catch (e) {}
                try {
                    this.logoEl.style.removeProperty("height");
                } catch (e) {}
                done();
            },
        }).add({
            easing: 'easeInBack',
            targets: this.logoEl,
            scale: [1, 0],
            opacity: [1, 0],
            height: [from, 0],
            duration: 150,
        }).add({
            targets: this.contentEl,
            height: [from, target],
            duration: 350
        }, 50)
    }
}
